import { render, staticRenderFns } from "./new-good-tag.vue?vue&type=template&id=7a95ae1c&scoped=true"
import script from "./new-good-tag.vue?vue&type=script&lang=js"
export * from "./new-good-tag.vue?vue&type=script&lang=js"
import style0 from "./new-good-tag.vue?vue&type=style&index=0&id=7a95ae1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a95ae1c",
  null
  
)

export default component.exports